import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import {
  DialogGreyOutlinedButton,
  ElevatedGreenButton,
} from "../Button/CustomButton";

import {
  customButtonStyle,
  StyledStepper,
  StyledStepperBox,
} from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCorpsMember, RestoreCorpsMember } from "../../Actions/Users";
import { isSignedIn } from "../../Hooks/auth";
import {
  addBusinessManagement,
  fetchBusinessManagement,
  fetchTotalBusinessManagement,
  restoreBusinessInitial,
} from "../../Actions";
import validators from "../../Utils/Validators";
import { errors } from "../../Utils/ErrorMessages/businessmgt";
import FormOne from "../MangeSuccessfulBusiness/FormOne";
import FormTwo from "../MangeSuccessfulBusiness/FormTwo";
import { Stack } from "@mui/material";
import NotificationUI from "./NotificationUI";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { StepperActiveIcon, StepperCheckIcon, StepperFailedIcon } from "../../Assets/svgs";

const getCMState = (state) => state.usersReducer;
const getBusinessState = (state) => state.businessReducer;
const steps = ["Business created successfully", "Business awaiting approval", "Business approved"];

export default function ProgressUI({

}) {

  const [activeStep, setActiveStep] = useState(2);
  const [status, setStatus] = useState("success");


  const isStepFailed = (step) => {
    return step === 2 && status === "failed" && activeStep === 2;
  };
  return (
    <Stack  alignItems={"center"} sx={{p:{xs:2, md:8}}}>
      <StyledStepperBox>
        <StyledStepper
          activeStep={activeStep}
          sx={{ position: "sticky", top: 0 }}
          alternativeLabel
        >
          {steps.map((label, index) => {
            const labelProps = {};
            if (isStepFailed(index)) {
              // labelProps.error = true;
              // labelProps?.
              if (isStepFailed(index)) {
                labelProps.optional = (
                  <Typography variant="caption" color="#A0A4A8" sx={{fontSize:{xs:"10px",md:"14px"}}}>
                    Business not approved
                  </Typography>
                );
                return <Step key={label}><StepLabel icon={<StepperFailedIcon />}> {labelProps?.optional}</StepLabel></Step>; // Return an empty Step for the failed step

              }
            }
            return (
              <Step key={label}>
                <StepLabel
                  icon={
                    activeStep >= index ? <StepperActiveIcon /> : <StepperCheckIcon />
                  }
                >
                  <Typography variant="caption" sx={{fontSize:{xs:"10px",md:"14px"}}}color={activeStep>=index?"#25282B":"#A0A4A8"} fontWeight={activeStep>=index?600:400}>
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            );
          })}
        </StyledStepper>
        {activeStep === 0 || activeStep === 1 ?
          <NotificationUI status={"info"} />
          : activeStep === ((steps?.length) - 1) ?
            <NotificationUI status={status !== "info" && status} />
            : ""}
      </StyledStepperBox>
    </Stack>

  );
}
